import React, { useState, useRef, useEffect } from "react";

const Chat = () => {
  const [input, setInput] = useState("");
  const [msgs, setMsgs] = useState([]);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    const text = input.trim();
    if (!text) return;

    // 1) show user message
    setMsgs((m) => [...m, { id: Date.now(), from: "user", text }]);
    setInput("");

    // 2) call backend
    try {
      const res = await fetch(
        "https://krishimart-back.onrender.com/api/v2/chatbot/chat",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: text })
        }
      );
      if (!res.ok) throw new Error(`Status ${res.status}`);
      const { faqResponse, aiResponse } = await res.json();

      const reply = faqResponse || aiResponse || "Sorry, I don't know.";
      setMsgs((m) => [
        ...m,
        { id: Date.now() + 1, from: "bot", text: reply }
      ]);
    } catch (err) {
      console.error(err);
      setMsgs((m) => [
        ...m,
        { id: Date.now() + 2, from: "bot", text: "Error, please try again." }
      ]);
    }
  };

  return (
    <div className="flex flex-col h-full max-w-lg mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="flex-1 p-4 overflow-y-auto space-y-4">
        {msgs.map((m) => (
          <div
            key={m.id}
            className={m.from === "user" ? "text-right" : "text-left"}
          >
            <div
              className={`inline-block px-4 py-2 rounded-lg ${
                m.from === "user"
                  ? "bg-green-200 text-green-800"
                  : "bg-gray-200 text-gray-800"
              }`}
            >
              {m.text}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      <form
        onSubmit={send}
        className="flex items-center border-t border-gray-300 p-3"
      >
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your question…"
          className="flex-1 px-4 py-2 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-400"
        />
        <button
          type="submit"
          className="ml-2 px-5 py-2 bg-green-500 hover:bg-green-600 text-white rounded-full font-semibold"
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default Chat;
